import { Box, Typography } from "@mui/material";
import { ServiceIcon } from "../../../settings-screens/schedules/components/ScheduleCustomEvent";
import { OverlayEvent } from "./overlay.types";

type OverlayEventContentProps = {
    event: OverlayEvent;
};

const MAX_VISIBLE_SERVICE_ICONS = 3;

export const OverlayEventContent = ({ event }: OverlayEventContentProps) => {
    const firstName = event.title || event.userName?.split(" ")[0] || "";
    const serviceIcons = (event.serviceIds || []).slice(0, MAX_VISIBLE_SERVICE_ICONS);

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, width: "100%", pointerEvents: "none" }}>
            <Typography variant="caption" sx={{ fontSize: "10px", lineHeight: 1, flexShrink: 0 }}>
                {firstName}
            </Typography>
            {serviceIcons.map((serviceId) => (
                <ServiceIcon key={serviceId} service_id={serviceId} styles={{ fontSize: "12px" }} />
            ))}
        </Box>
    );
};
